// File: src/utils/transponders.js
// Transponder models an event can declare support for.
//
// These values are the members of the `supported_transponders` SET column in
// MariaDB, so they must stay in sync with the matching list in backend/server.js
// and with the migration. Adding a model means an ALTER TABLE, not just an edit
// here.

export const TRANSPONDER_TYPES = [
  { value: 'RC4', label: 'RC4' },
  { value: 'RC4_HYBRID', label: 'RC4 Hybrid' },
  { value: 'RC4_PRO', label: 'RC4 Pro' },
  { value: 'LEGACY_AMB', label: 'Legacy AMB' },
  { value: 'LEGACY_RC2', label: 'Legacy RC2' }
];

// Values only, for validation.
export const TRANSPONDER_VALUES = TRANSPONDER_TYPES.map(t => t.value);

// Display label for a stored value, falling back to the raw value so an unknown
// member from a newer backend still renders as something.
export const transponderLabel = (value) =>
  TRANSPONDER_TYPES.find(t => t.value === value)?.label || value || '';

// MariaDB returns a SET as a comma-separated string; the API may also hand back
// an array. Normalise both to an array of known values.
export const parseTransponderSet = (value) => {
  if (!value) return [];
  const list = Array.isArray(value) ? value : String(value).split(',');
  return list.map(v => v.trim()).filter(v => TRANSPONDER_VALUES.includes(v));
};
